import axios from "axios";
import Config from "../../../config";

const v2_actionListScoringDefinitions = (clienteId) => {
    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/${clienteId}/crm/scoring/definitions`,
    });
};

export default v2_actionListScoringDefinitions;
